import type { AxiosInstance, AxiosResponse } from 'axios';

import type { QuestionChoice } from '@/models/question';
import type { QuestionType } from '@/models/questionType';
import type { RootResponse } from '@/models/rootResponse';

export type CreateQuestionChoice = {
   body: QuestionChoice;
};

class QuestionTypeService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getQuestionTypes(): Promise<RootResponse<QuestionType[]>> {
      const response: AxiosResponse<RootResponse<QuestionType[]>> =
         await this.provider.post('/question-types/search');
      return response.data;
   }
}

export default QuestionTypeService;
